import { Users, Briefcase, Sparkles } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Reveal } from "@/lib/reveal";

const STATIC = [
  { name: "Suzuki S-Cross Hybrid", image: "/fleet/suzuki-s-cross.png" },
  { name: "Toyota Yaris Cross Hybrid", image: "/fleet/toyota-yaris-cross.png" },
  { name: "Škoda Scala", image: "/fleet/skoda-scala.png" },
];

export default function Fleet() {
  const { t } = useLang();
  const cars = t("fleet.cars");

  return (
    <section id="fleet" data-testid="fleet-section" className="relative py-28 lg:py-32 px-6 lg:px-10 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">{t("fleet.eyebrow")}</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white font-light tracking-tight">
            {t("fleet.title_a")}<span className="italic text-[#C5A059]">{t("fleet.title_b")}</span>
          </h2>
          <p className="text-zinc-400 mt-6 max-w-2xl mx-auto leading-relaxed">{t("fleet.sub")}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {STATIC.map((car, i) => {
            const c = cars[i] || {};
            return (
              <Reveal key={car.name} delay={i * 90}>
                <article
                  data-testid={`fleet-card-${i}`}
                  className="group relative bg-[#0d0d0d] border border-white/10 rounded-xl overflow-hidden transition-all duration-500 hover:border-[#C5A059]/40 hover:-translate-y-0.5"
                >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={car.image}
                    alt={car.name}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d] via-[#0d0d0d]/30 to-transparent" />
                </div>

                <div className="p-8">
                  <h3 className="font-display text-2xl text-white font-normal">{car.name}</h3>
                  <p className="text-sm italic text-[#C5A059] mt-1 mb-6">{c.tagline}</p>

                  <div className="space-y-3 text-sm text-zinc-400">
                    <div className="flex items-center gap-3"><Users className="w-4 h-4 text-zinc-500" /><span>{c.passengers}</span></div>
                    <div className="flex items-center gap-3"><Briefcase className="w-4 h-4 text-zinc-500" /><span>{c.luggage}</span></div>
                    <div className="flex items-center gap-3"><Sparkles className="w-4 h-4 text-zinc-500" /><span>{c.perk}</span></div>
                  </div>
                </div>
              </article>
              </Reveal>
            );
          })}
        </div>

        <p
          data-testid="fleet-trust-caption"
          className="mt-10 text-center text-sm text-zinc-500 italic max-w-2xl mx-auto"
        >
          {t("fleet.trust_caption")}
        </p>
      </div>
    </section>
  );
}
